export default defineNuxtPlugin(() => {
  const router = useRouter()

  if (process.client) window.history.scrollRestoration = 'manual'

  router.options.scrollBehavior = () => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }
})
